import {
  Box,
  Button,
  Flex,
  Spinner,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AlertModal from "../../../Modals/AlertModal";
import { mixpanelTrackButton } from "../../../utils/mixpanelFunctions";
import TentativeBurdenMix from "../../TentativeBurdenMix";
import { RecursiveInput } from "./RecursiveInput";
import {
  getNestedStepsDataApi,
  getTentativeBurdenMixApi,
  updateNestedStateDataApi,
} from "./services/nestedStepsServices";

export const NestedSteps = () => {
  const [nestedStepsData, setNestedStepsData] = useState(null);
  const [tentativeBurdenMixData, setTentativeBurdenMixData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingTentativeBurdenMix, setLoadingTentativeBurdenMix] =
    useState(false);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [enableEdit, setEnableEdit] = useState(false);
  const controllers = useSelector((state) => state.app.bounds.controllers);
  const handleClick = () => {
    enableEdit ? onOpen() : setEnableEdit((prev) => !prev);
    mixpanelTrackButton(
      "review constraints steps",
      enableEdit ? "SAVE" : "ENABLE EDITING"
    ); // track button
  };

  const handleCancelEdit = () => {
    console.log("cacelClick");
    // make a get request to update state again;
    getNestedStepsDataApi(setLoading)
      .then((res) => {
        console.log(res);
        setNestedStepsData((prev) => res);
        setEnableEdit((prev) => !prev);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleConfirmEdit = async () => {
    try {
      const updateResponse = await updateNestedStateDataApi(nestedStepsData);
      console.log(updateResponse);
      if (updateResponse.status === true) {
        // fetching tentative burden mix data
        const tentativeBurdenMixResponse = await getTentativeBurdenMixApi(
          setLoadingTentativeBurdenMix
        );
        if (
          tentativeBurdenMixResponse?.success &&
          tentativeBurdenMixResponse?.data
        ) {
          setTentativeBurdenMixData((prev) => tentativeBurdenMixResponse.data);
          setEnableEdit((prev) => !prev);
          // success
          // close all the previous toast
          toast.closeAll();
          toast({
            title: updateResponse.message,
            status: "success",
            isClosable: true,
            duration: 3000,
          });
        } else {
          toast.closeAll();
          toast({
            title: tentativeBurdenMixResponse.message,
            status: "error",
            isClosable: true,
            duration: null,
          });
        }
      }
    } catch (error) {
      console.log(error);
      //error
      toast.closeAll();
      toast({
        title: "Error while updating",
        status: "error",
        isClosable: true,
        description: "Please try again",
        duration: null,
      });
    } finally {
      getNestedStepsDataApi(setLoading)
        .then((res) => {
          console.log(res);
          setNestedStepsData((prev) => res);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const clearAllValuesRecursively = (data) => {
    if (!data || typeof data !== "object") return;

    Object.keys(data).forEach((key) => {
      if (data[key] && typeof data[key] === "object") {
        // If the key is an object, call the function recursively
        clearAllValuesRecursively(data[key]);
      }
      if (key === "value") {
        // If the key is 'value', reset it to null
        data[key] = null;
      }
    });
  };

  // Function to clear the state
  console.log("Before Clearing:1", nestedStepsData);

  const clearAllValueFromRecursiveInput = (nestedStepsDataToModify) => {
    const updatedData = { ...nestedStepsDataToModify };
    clearAllValuesRecursively(updatedData);
    setNestedStepsData((prev) => updatedData);
  };

  //   to load data on initial mount
  useEffect(() => {
    // console.log("mount");
    getNestedStepsDataApi(setLoading)
      .then((res) => {
        console.log(res);
        setNestedStepsData((prev) => res);
      })
      .catch((error) => {
        console.log(error);
      });
    getTentativeBurdenMixApi(setLoadingTentativeBurdenMix)
      .then((res) => {
        console.log(res);
        if (res.success) {
          setTentativeBurdenMixData(res.data);
        } else {
          toast.closeAll();
          toast({
            title: res?.message || "Unexpected Error",
            status: "error",
            isClosable: true,
            duration: null,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // return () => {
    //   console.log("unmount");
    // };
  }, []);

  return (
    <>
      <Box w="100%">
        <Flex w="98%" direction="row" mb="1rem" justify="start" gap={2}>
          <Button
            p="0"
            colorScheme="blue"
            w="150px"
            type="submit"
            onClick={handleClick}
            fontSize="12px"
          >
            {enableEdit ? "SAVE" : "ENABLE EDITING"}
          </Button>
          <Button
            p="0"
            colorScheme="blue"
            w="150px"
            type="submit"
            onClick={() => clearAllValueFromRecursiveInput(nestedStepsData)}
            fontSize="12px"
            isDisabled={!enableEdit}
          >
            {"CLEAR ALL"}
          </Button>
        </Flex>
        <AlertModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          title="Upadate steps"
          body="Are you sure? You want to change these steps"
          colorScheme="red"
          onSubmit={handleConfirmEdit}
          onCancel={handleCancelEdit}
        />
        <Flex w="100%" gap="2rem" alignItems="top">
          <Box w={"50%"} overflowX={"auto"}>
            {loading ? (
              <div className="flex w-full h-[60vh] items-center justify-center">
                <Spinner size={"xl"} />
              </div>
            ) : (
              <>
                {nestedStepsData && (
                  <RecursiveInput
                    data={nestedStepsData}
                    setData={setNestedStepsData}
                    enableEdit={enableEdit}
                  />
                )}
              </>
            )}
          </Box>
          <Box w="50%">
            {loadingTentativeBurdenMix ? (
              <div className="flex w-full h-[60vh] items-center justify-center">
                <Spinner size={"xl"} />
              </div>
            ) : (
              <>
                {tentativeBurdenMixData && (
                  <>
                    <Text>{"Tentative Burden Mix".toLocaleUpperCase()}</Text>
                    <TentativeBurdenMix data={tentativeBurdenMixData} />
                  </>
                )}
              </>
            )}
          </Box>
        </Flex>
      </Box>
    </>
  );
};
